import { RegistrationFormData } from '../../RegistrationModal';

export type RegistrationFormLabels = {
  [key in keyof Omit<
    RegistrationFormData,
    'acceptedTermsAndConditionsAt' | 'recaptchaToken'
  >]: string;
} & {
  isInternalVolunteerYes: string;
  isInternalVolunteerNo: string;
};

export const DEFAULT_LABELS = {
  firstName: 'First name',
  lastName: 'Last name',
  phone: 'Phone number',
  email: 'Email',
  birthDate: 'Date of birth',
  gender: 'Gender',
  isInternalVolunteer: 'Do you belong to this organization?',
  acceptedPhoneTermsAt:
    'By providing my phone number, I agree to receive text messages from the organization.',
  acceptedCancellationPolicyAt:
    'I understand the Cancellation & Unregistration policy.',
  prefersSpanishCommunication: 'I prefer to receive communication in Spanish.',
  isInternalVolunteerYes: 'Yes, I belong to this organization.',
  isInternalVolunteerNo: "No, I don't belong to this organization."
} satisfies RegistrationFormLabels;

export const PARTNER_LABELS = {
  ...DEFAULT_LABELS,
  prefersSpanishCommunication:
    'They prefer to receive communication in Spanish.',
  isInternalVolunteer: 'Is the volunteer a member of your organization?',
  acceptedPhoneTermsAt:
    "By providing the volunteer's phone number, they agree to receive text messages from the organization.",
  acceptedCancellationPolicyAt:
    'The volunteer understands the Cancellation & Unregistration policy.',
  isInternalVolunteerYes: 'Yes, they belong to this organization.',
  isInternalVolunteerNo: "No, they don't belong to this organization."
} satisfies RegistrationFormLabels;
